import React, { useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';
import { SgDateUtil } from 'saga-modules';
import _ from 'lodash';
import messages from './SgDriversSummary.messages';

function SgDriversSummary(props) {
    const {
        modelVM
    } = props;

    const translator = useContext(TranslatorContext);

    const renderDrivers = () => {
        const drivers = _.get(modelVM, 'lobData.privateMotor.coverables.spmDrivers.value');
        const filteredDrivers = _.filter(drivers, (driver) => {
            return driver.publicID !== undefined;
        });
        const sortedDrivers = _.sortBy(filteredDrivers, (driver) => {
            return parseInt(driver.publicID, 10);
        });

        return sortedDrivers.map((driver) => {
            return (
                <tr key={driver.publicID}>
                    <td>{driver.person.displayName}</td>
                    <td>
                        {SgDateUtil.toStringShort(driver.person.dateOfBirth)}
                    </td>
                </tr>
            );
        });
    };

    return (
        <div className="sgMtaDriversListContainer">
            <h3>{translator(messages.Header)}</h3>
            <table id="driverList" className="sgMtaDriversListTable">
                <thead>
                    <tr>
                        <th>{translator(messages.Name)}</th>
                        <th>{translator(messages.DOB)}</th>
                    </tr>
                </thead>
                <tbody>
                    {renderDrivers()}
                </tbody>
            </table>
        </div>
    );
}

export default SgDriversSummary;
